import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const whiteSpace = system({
    whiteSpace: true,
});

export interface WhiteSpaceProps<ThemeType extends Theme = RequiredTheme> {
    whiteSpace?: ResponsiveValue<CSS.Property.WhiteSpace, ThemeType> | undefined;
}
